import { migrateProject, type Project } from "./types";

export const FILE_KIND = "mirancho-project";

export interface ProjectFile {
  kind: typeof FILE_KIND;
  title: string;
  exportedAt: number;
  data: Project;
}

export function buildProjectFile(title: string, data: Project): ProjectFile {
  return {
    kind: FILE_KIND,
    title: title.trim() || "Mi rancho",
    exportedAt: Date.now(),
    data,
  };
}

export function parseProjectFile(raw: unknown): { title: string; data: Project } {
  if (!raw || typeof raw !== "object") throw new Error("formato");
  const obj = raw as { kind?: string; title?: string; data?: unknown };
  const title =
    obj.kind === FILE_KIND && obj.title
      ? String(obj.title).trim() || "Mi rancho"
      : obj.title
        ? String(obj.title).trim()
        : "Importado";
  return { title, data: migrateProject(raw) };
}

export function fileNameFromTitle(title: string): string {
  const slug = title
    .trim()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^\w\s-]/g, "")
    .replace(/\s+/g, "-")
    .slice(0, 60);
  return `${slug || "mi-rancho"}.json`;
}
